import { crc16 } from '../utils/crc';

export default {
    /**
     * VAlidate TON Address
     * https://github.com/ton-core/ton-core/blob/8dff175691823bfd0b6cd90300bb74860f740503/src/address/Address.ts#L16
     * @param {string} address 
     * @returns {boolean}
     */
    isValidAddress(address) {

        if (address.length !== 48) {
            return false;
        }

        const data = Buffer.isBuffer(address) ? address : Buffer.from(address, 'base64');
        // 1byte tag + 1byte workchain + 32 bytes hash + 2 byte crc
        if (data.length !== 36 ) {
            return false;
        }

        // Prepare data
        const addr = data.subarray(0, 34);
        const crcSub = data.subarray(34, 36);
        const calcedCrc = crc16(addr);
        if (!(calcedCrc[0] === crcSub[0] && calcedCrc[1] === crcSub[1])) {
            return false;
        }

        return true;
    },
};
